import React, { Fragment } from 'react';
import SplashHero from '../features/splash/SplashHero';
import SplashNarrative from '../features/splash/SplashNarrative';
import SplashExplanation from '../features/splash/SplashExplanation';
import ToolPicker from '../features/splash/ToolPicker';

function SplashPage() {
  return (
    <Fragment>
      <SplashHero />
      <SplashNarrative />
      <SplashExplanation />
      <ToolPicker />
    </Fragment>
  );
}

export default SplashPage;



// WEBPACK FOOTER //
// ./src/components/pages/SplashPage.js